const APP_SOURCE_KEY = 'source';

export const ALLOWED_SOURCES = {
  allHere: 'AllHere',
};

export const ALLOWED_RECEIVERS = {
  [ALLOWED_SOURCES.allHere]: 'ed',
};

export const getAppSource = () => sessionStorage.getItem(APP_SOURCE_KEY);

export const saveAppSource = (source) => sessionStorage.setItem(APP_SOURCE_KEY, source);

export const initAppSource = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const source = searchParams.get('source');

  if (source) {
    saveAppSource(source);
  }
};
